module.exports = __webpack_public_path__ + "img/book_title_bac.8ed2a4bb.png";